import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { LOGO, WA, INSTA, TIKTOK } from '../../constants';
import { ExternalLink } from '../ui';

const Footer = () => {
  const footerLinks = ['Serviços', 'Sobre', 'Contato'];

  return (
    <footer className="bg-goshine-navy py-10 sm:py-12 lg:py-16">
      <div className="container mx-auto px-4">
        {/* Logo & Description */}
        <div className="flex flex-col items-center text-center mb-8 lg:mb-12">
          <img src={LOGO} alt="GoShine" className="h-10 sm:h-12 lg:h-14 mb-4 lg:mb-6" />
          <p className="text-gray-400 text-sm max-w-md leading-relaxed">
            Transformando carros e superando expectativas desde 2019.
          </p>
          
          {/* Social Icons */}
          <div className="flex gap-3 mt-4">
            <ExternalLink 
              href={INSTA} 
              className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-pink-500/20 transition-colors"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-gray-400 hover:text-pink-500" />
            </ExternalLink>
            <ExternalLink 
              href={TIKTOK} 
              className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
            >
              <FontAwesomeIcon icon={faTiktok} className="text-gray-400 hover:text-white" />
            </ExternalLink>
            <ExternalLink 
              href={WA} 
              className="w-10 h-10 bg-white/5 rounded-lg flex items-center justify-center hover:bg-green-500/20 transition-colors"
            >
              <FontAwesomeIcon icon={faWhatsapp} className="text-gray-400 hover:text-green-500" />
            </ExternalLink>
          </div>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-400 mb-6">
          {footerLinks.map(link => (
            <a 
              key={link} 
              href={`#${link.toLowerCase()}`} 
              className="hover:text-goshine-orange transition-colors"
            >
              {link}
            </a>
          ))}
        </div>

        {/* Contact Info */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs sm:text-sm text-gray-500 mb-6">
          <span>
            <FontAwesomeIcon icon={faPhone} className="mr-1.5 text-goshine-orange" />
            +55 48 9215-2728
          </span>
          <span>
            <FontAwesomeIcon icon={faLocationDot} className="mr-1.5 text-goshine-orange" />
            Santa Monica, Florianópolis
          </span>
        </div>

        {/* Copyright & Credits */}
        <div className="border-t border-white/10 pt-6 text-center space-y-4">
          <p className="text-gray-500 text-xs sm:text-sm">
            © {new Date().getFullYear()} GoShine. Todos os direitos reservados.
          </p>
          <ExternalLink 
            href="https://agenciastro.com.br/" 
            className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#5b7bf5]/50 rounded-full px-4 py-2 transition-colors group"
          >
            <img 
              src="/astro-logo.png" 
              alt="Astro Tech Hub" 
              className="h-7 w-7 group-hover:scale-110 transition-transform" 
            />
            <span className="text-gray-400 text-xs">Desenvolvido por</span>
            <span className="text-[#5b7bf5] font-semibold text-sm">Astro Tech Hub</span>
          </ExternalLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
